{
  "pages": {
    "listTitle": "Khuyến mãi",
    "addTitle": "Thêm khuyến mãi",
    "editTitle": "Sửa khuyến mãi",
    "permissionDenied": "Bạn không có quyền xem khuyến mãi.",
    "createPermissionDenied": "Bạn không có quyền tạo khuyến mãi.",
    "editPermissionDenied": "Bạn không có quyền sửa khuyến mãi."
  },
  "status": {
    "draft": "Nháp",
    "active": "Đang chạy",
    "inactive": "Đã tắt"
  },
  "types": {
    "wallet_topup_bonus": "KM nạp tiền TK nạp trước",
    "voucher": "Voucher",
    "treatment_discount": "Giảm giá kế hoạch",
    "service_discount": "Giảm giá dịch vụ"
  },
  "voucherStatus": {
    "available": "Còn dùng",
    "used": "Đã dùng",
    "unavailable": "Không dùng được"
  },
  "unavailableReason": {
    "manual": "Đã khóa thủ công",
    "promotion_expired": "Chương trình hết hạn",
    "promotion_inactive": "Chương trình đã tắt"
  },
  "fields": {
    "name": "Tên khuyến mãi",
    "code": "Mã",
    "type": "Loại",
    "status": "Trạng thái",
    "description": "Mô tả",
    "startDate": "Ngày bắt đầu",
    "endDate": "Ngày kết thúc",
    "priority": "Độ ưu tiên",
    "stackable": "Cộng dồn được",
    "benefitType": "Loại ưu đãi",
    "benefitValue": "Giá trị ưu đãi",
    "minTopup": "Nạp tối thiểu",
    "maxBonus": "Thưởng tối đa",
    "discountPercent": "Giảm %",
    "discountAmount": "Giảm cố định",
    "voucherPrefix": "Tiền tố mã",
    "voucherCount": "Số mã tạo",
    "maxRedemptions": "Số lần dùng tối đa",
    "minimumCondition": "Điều kiện tối thiểu",
    "period": "Thời hạn",
    "benefit": "Ưu đãi",
    "bonusType": "Loại thưởng",
    "discountType": "Loại giảm",
    "percent": "Phần trăm (%)",
    "fixed": "Cố định",
    "bonusPercent": "Phần trăm thưởng",
    "bonusAmount": "Số tiền thưởng",
    "minPayment": "TT tối thiểu",
    "discountPercentValue": "Phần trăm giảm",
    "discountAmountValue": "Số tiền giảm",
    "maxDiscountOptional": "Giảm tối đa (tùy chọn)",
    "minPlanSubtotal": "Kế hoạch tối thiểu",
    "maxRedemptionsTotal": "Giới hạn / Tổng lượt dùng",
    "maxRedemptionsPerPatient": "Giới hạn / khách hàng",
    "initialCodeCount": "Số mã phát hành",
    "initialCodeCountHint": "Để trống nếu chưa sinh mã. Tối đa 500.",
    "targetCategories": "Nhóm dịch vụ áp dụng",
    "targetCatalogItems": "Dịch vụ áp dụng",
    "serviceTargetHint": "Chọn ít nhất một nhóm hoặc dịch vụ",
    "priorityHint": "Cao hơn thắng khi nhiều KM cùng khớp",
    "priorityLow": "Thấp (10)",
    "priorityMedium": "Trung bình (20)",
    "priorityHigh": "Cao (30)",
    "quantity": "Số lượng",
    "batch": "Lô",
    "usedOn": "Dùng tại",
    "usedAt": "Thời điểm"
  },
  "actions": {
    "add": "Thêm khuyến mãi",
    "edit": "Sửa",
    "history": "Lịch sử",
    "deactivate": "Tắt",
    "activate": "Bật",
    "save": "Lưu",
    "saveDraft": "Lưu nháp",
    "saveAndActivate": "Lưu và chạy",
    "saveAndDeactivate": "Lưu và tắt",
    "cancel": "Hủy",
    "refresh": "Làm mới",
    "generateCodes": "Tạo mã voucher",
    "disableCode": "Khóa mã",
    "manageVouchers": "Quản lý voucher"
  },
  "table": {
    "name": "Tên",
    "type": "Loại",
    "status": "Trạng thái",
    "period": "Thời gian",
    "actions": "Thao tác",
    "code": "Mã",
    "voucherStatus": "Trạng thái mã",
    "benefit": "Ưu đãi",
    "minimumCondition": "Điều kiện tối thiểu",
    "serviceTargetSummary": "{{categories}} nhóm / {{services}} DV",
    "priority": "Ưu tiên",
    "batch": "Lô",
    "usedOn": "Dùng tại",
    "usedAt": "Thời điểm"
  },
  "dialogs": {
    "deactivateConfirm": "Tắt khuyến mãi này?",
    "disableCodeConfirm": "Khóa mã voucher này?",
    "generateTitle": "Tạo mã voucher",
    "deactivateNamedConfirm": "Tắt chương trình \"{{name}}\"?",
    "disableNamedCodeConfirm": "Tắt mã \"{{code}}\"?",
    "voucherCodesTitle": "Mã KM — {{name}}",
    "overlapTitle": "Trùng với KM đang chạy",
    "overlapMessage": "Chương trình này có thể chồng với: {{names}}. Vẫn lưu?",
    "overlapConfirm": "Vẫn lưu"
  },
  "empty": "Không tìm thấy khuyến mãi",
  "validation": {
    "nameRequired": "Vui lòng nhập tên khuyến mãi",
    "nameTooLong": "Tên khuyến mãi tối đa {{max}} ký tự",
    "nameDuplicate": "Tên khuyến mãi đã tồn tại",
    "typeRequired": "Vui lòng chọn loại",
    "datesRequired": "Vui lòng chọn thời gian",
    "minTopupInvalid": "Số tiền nạp tối thiểu không hợp lệ",
    "bonusInvalid": "Giá trị thưởng không hợp lệ",
    "discountInvalid": "Giá trị giảm không hợp lệ",
    "serviceTargetRequired": "Chọn ít nhất một nhóm dịch vụ hoặc dịch vụ áp dụng",
    "minAmountInvalid": "Số tiền tối thiểu không hợp lệ",
    "endBeforeStart": "Ngày kết thúc phải cùng ngày hoặc sau ngày bắt đầu",
    "redemptionLimitInvalid": "Giới hạn lượt dùng phải từ 1 trở lên"
  },
  "toasts": {
    "loadFailed": "Không tải được danh sách khuyến mãi",
    "created": "Đã tạo khuyến mãi",
    "createFailed": "Tạo khuyến mãi thất bại",
    "updated": "Đã cập nhật khuyến mãi",
    "updateFailed": "Cập nhật thất bại",
    "deactivated": "Đã tắt khuyến mãi",
    "activated": "Đã bật khuyến mãi",
    "actionFailed": "Thao tác thất bại",
    "codesGenerated": "Đã tạo mã voucher",
    "codeDisabled": "Đã khóa mã voucher"
    ,"codesLoadFailed": "Không tải được danh sách mã",
    "invalidCodeCount": "Số lượng phải từ 1 đến 500",
    "codesGeneratedCount": "Đã sinh {{count}} mã KM",
    "codesGenerateFailed": "Sinh mã thất bại",
    "codeCopied": "Đã sao chép mã",
    "codeDeactivated": "Đã tắt mã",
    "codeDeactivateFailed": "Không thể tắt mã",
    "promotionDeactivated": "Đã tắt chương trình KM",
    "deactivateFailed": "Không thể tắt chương trình",
    "createSuccess": "Tạo khuyến mãi thành công",
    "createSuccessWithCodes": "Đã tạo khuyến mãi và sinh {{count}} mã",
    "codesGenerateAfterCreateFailed": "Đã tạo khuyến mãi nhưng sinh mã thất bại. Dùng \"Quản lý mã\" để thử lại.",
    "saveFailed": "Lưu khuyến mãi thất bại",
    "updateSuccess": "Cập nhật khuyến mãi thành công"
  },
  "placeholders": {
    "search": "Tìm theo tên, loại, trạng thái…",
    "name": "Ví dụ: Giảm 10% cạo vôi",
    "description": "Mô tả điều kiện áp dụng",
    "minTopup": "100000",
    "bonusPercent": "10",
    "bonusAmount": "50000",
    "maxBonus": "Để trống nếu không giới hạn",
    "minPayment": "200000",
    "discountPercent": "10",
    "discountAmount": "50000",
    "maxDiscount": "Để trống nếu không giới hạn",
    "minPlanSubtotal": "500000",
    "maxRedemptionsTotal": "Để trống nếu không giới hạn",
    "maxRedemptionsPerPatient": "Để trống nếu không giới hạn",
    "initialCodeCount": "50",
    "targetCategories": "Chọn nhóm dịch vụ",
    "targetCatalogItems": "Chọn dịch vụ",
    "endDate": "Không bắt buộc"
  },
  "voucher": {
    "generate": "Sinh mã",
    "empty": "Chưa có mã KM. Sinh lô mã ở trên.",
    "emptyFiltered": "Không tìm thấy mã phù hợp bộ lọc.",
    "paymentReference": "Thanh toán #{{id}}",
    "searchLabel": "Tìm mã",
    "searchPlaceholder": "Tìm mã…",
    "statusAll": "Tất cả",
    "summaryTotal": "Tổng {{count}}",
    "summaryAvailable": "Còn {{count}}",
    "summaryUsed": "Đã dùng {{count}}",
    "summaryExpired": "Hết hạn {{count}}",
    "summaryDisabled": "Đã khóa {{count}}"
  },
  "history": {
    "title": "Lịch sử",
    "empty": "Chưa có hoạt động nào được ghi nhận."
  },
  "emptyList": "Chưa có chương trình khuyến mãi",
  "emptySearch": "Không tìm thấy khuyến mãi phù hợp",
  "manageVoucherCodes": "Quản lý mã voucher",
  "filters": {
    "trigger": "Bộ lọc",
    "title": "Lọc khuyến mãi",
    "clearAll": "Xóa tất cả",
    "apply": "Áp dụng",
    "status": "Trạng thái",
    "type": "Loại khuyến mãi",
    "statusAll": "Tất cả trạng thái",
    "typeAll": "Tất cả loại",
    "dateRange": "Khoảng thời gian",
    "dateRangePlaceholder": "Chọn khoảng ngày",
    "selectStatus": "Chọn trạng thái",
    "selectType": "Chọn loại khuyến mãi",
    "selectPriority": "Chọn độ ưu tiên",
    "selectClinic": "Chọn phòng khám",
    "priority": "Độ ưu tiên",
    "priorityAll": "Tất cả mức ưu tiên",
    "clinic": "Phòng khám",
    "allClinics": "Tất cả phòng khám"
  }
}
